import { render } from "./TeamEdit.vue?vue&type=template&id=b6f02c76"
import script from "./TeamEdit.vue?vue&type=script&lang=js"
export * from "./TeamEdit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__